// extracted by mini-css-extract-plugin
module.exports = {"order":"Paginado_order__3DRt4","active":"Paginado_active__sO_yw"};